(function() {
	'use strict';

	angular
		.module('smb-app')
		.factory('smbEnvironmentService', [
			'$window',
			'pxEnvironmentService',
			EnvironmentService
		]);

	function EnvironmentService($window, pxEnvironmentService) {
		var ua = $window.navigator.userAgent;
		var defaults = {
			configurable: false,
			enumerable: true
		};

		// http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
		var service = Object.create(pxEnvironmentService, {
			isIE: angular.merge({
				value: ua.indexOf('Trident') >= 0
			}, defaults),
			isFireFox: angular.merge({
				value: ua.indexOf('Mozilla') >= 0 && (typeof $window.InstallTrigger !== 'undefined')
			}, defaults)
		});

		return service;
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/environmentService.js
// module id = 152
// module chunks = 1